import { DOMSTRING, anchorID } from './init';

const HEADING_SELECTOR = 'h2, h3, h4, h5, h6';
const DEFAULT_MAX_DEPTH = 5;

const getHeadingLevel = (heading) => Number.parseInt(heading.tagName.slice(1), 10);

const getHeadingText = (heading) => heading.textContent.trim();

const ensureHeadingAnchor = (heading, fallbackIndex, usedAnchors) => {
	let anchor = heading.id || `${anchorID}${fallbackIndex}`;

	if (usedAnchors.has(anchor)) {
		let suffix = 1;
		let candidate = `${anchor}-${suffix}`;
		while (usedAnchors.has(candidate)) {
			suffix += 1;
			candidate = `${anchor}-${suffix}`;
		}
		anchor = candidate;
	}

	heading.id = anchor;
	usedAnchors.add(anchor);

	return anchor;
};

export const parseMaxDepth = (tocElement) => {
	const depthAttribute = Number.parseInt(tocElement.getAttribute('data-depth'), 10);
	return Number.isNaN(depthAttribute) ? DEFAULT_MAX_DEPTH : Math.max(depthAttribute - 1, 0);
};

export const getHeadlines = (headlineIndex) => {
	if (!headlineIndex) {
		console.warn('Table of Contents: Content element not found');
		return [];
	}

	const allHeadlines = headlineIndex.querySelectorAll(HEADING_SELECTOR);
	const excludedHeadlines = headlineIndex.querySelectorAll(DOMSTRING.excludedHeadlines);
	const excludedSet = new Set(excludedHeadlines);

	return Array.from(allHeadlines).filter((headline) => {
		const isVisible = typeof headline.checkVisibility === 'function' ? headline.checkVisibility() : true;
		return !excludedSet.has(headline) && isVisible;
	});
};

export const normalizeHeadings = (headlines) => {
	const usedAnchors = new Set();

	return headlines.map((heading, index) => {
		const level = getHeadingLevel(heading);
		const text = getHeadingText(heading);
		const anchor = ensureHeadingAnchor(heading, index, usedAnchors);

		return {
			anchor,
			heading,
			level,
			text,
		};
	});
};

// depth=N means H2 through H(N+1): base is always H2, not the minimum heading found.
const BASE_HEADING_LEVEL = 2;

export const filterHeadlinesByDepth = (headlines, maxDepth) => {
	return headlines.filter((heading) => {
		const depth = heading.level - BASE_HEADING_LEVEL;
		return depth <= maxDepth;
	});
};
